export const gameSettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: true, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: true, // wether the opponent can call the wrong card
    true: -3, // the opponent gets minus three
    false: -2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,
  profile: {
    avatar: "https://teacherwilliam.sgp1.cdn.digitaloceanspaces.com/spar/spar-legends.jpeg", // the default avatar for the user
    banner: "https://teacherwilliam.sgp1.cdn.digitaloceanspaces.com/spar/banner.jpg", // the default banner for the user
  }, 

};

export const rankedSettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: false, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: true, // wether the opponent can call the wrong card
    true: -3, // the opponent gets minus three
    false: -2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,

};

export const quickPlaySettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: true, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: false, // wether the opponent can call the wrong card
    true: 3, // the opponent gets minus three
    false: 2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,

};

export const customGameSettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: false, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: true, // wether the opponent can call the wrong card
    true: 3, // the opponent gets minus three
    false: 2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,


};

export const aiGameSettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: true, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: false, // wether the opponent can call the wrong card
    true: 3, // the opponent gets minus three
    false: 2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,
}


export const tournamentSettings = {
  aiDifficulty: {
    beginner: 1,
    pro: 7,
    default: 7,
  },
  shuffleType: "half", // other option is full. wether a "full" deck is played before replaced with a new deck
  deckType: "sixToKing", // the deck type used
  gbaaProtection: false, // being able to play the wrong card and get away with it
  gbaaPenalty: {
    canCall: true, // wether the opponent can call the wrong card
    true: 3, // the opponent gets minus three
    false: 2, // the person who called it wrong gets minus two
  },
  winnerStart: false, // wether the winner of the previous round starts the next round
  dryMode: false, // revealing a 6 or a seven
  underTenEnabled: true, // wether the game is played with the under ten rule
  gameScore: {
    numberOfRounds: 10, // number of rounds to play
    pointsToWin: 10, // points to win the game
    direction: "asc", // wether point are up to down or down to up
  },
  searchTimeOut: 1 * 60 * 1000, // time for acceptnig the match
  timer: {
    timerEnabled: false, // timer for whether a there's a countdown for playing a card
    timerDuration: 20, // the duration of the timer in seconds
    timerWarning: 5, // the duration of the warning in seconds
    timerWarningEnabled: true, // wether the warning is enabled
  }, 
  inactivityTimeoutTime: 10 * 60 * 1000, // -- minutes in milliseconds for a game to be shut down,

}